'use client';

import type { ListCollection } from '@chakra-ui/react';
import { Box, Flex, Select } from '@chakra-ui/react';
import LucideIcon from '@/components/ui/LucideIcon';

interface ProductFinderSelectProps {
  label: string;
  collection: ListCollection<{ label: string; value: string }>;
  value: string[];
  onValueChange: (details: { value: string[] }) => void;
}

const ProductFinderSelect = ({ label, collection, value, onValueChange }: ProductFinderSelectProps) => {
  return (
    <Flex flexDirection="column" gap={4} width="100%">
      <Select.Root
        size="xs"
        multiple={false}
        collection={collection}
        deselectable={false}
        value={value}
        onValueChange={onValueChange}
        flexDirection={{ base: 'row', mobile: 'column' }}
        justifyContent={{ base: 'space-between', mobile: 'center' }}
      >
        <Select.HiddenSelect />
        <Select.Label textStyle="body2" fontWeight="regular" color="neutral.10">
          {label}
        </Select.Label>
        <Box paddingBottom={3} borderBottom="1px solid" borderColor="neutral.20">
          <Select.Control borderRadius={0} width={{ base: '163px', mobile: '100%' }}>
            <Select.Trigger border="none" minH="22px" padding={0}>
              <Select.ValueText
                textStyle={{ base: 'body2', tablet: 'heading2' }}
                color="common.100"
                fontWeight="regular"
              />
            </Select.Trigger>
            <Select.IndicatorGroup>
              <Select.Indicator>
                <LucideIcon name="ChevronDown" boxSize={6} strokeWidth="1px" color="common.100" />
              </Select.Indicator>
            </Select.IndicatorGroup>
          </Select.Control>
        </Box>
        <Select.Positioner>
          <Select.Content
            backgroundColor="common.100"
            borderRadius="8px"
            boxShadow="0 4px 6px rgba(0,0,0,0.1)"
            maxHeight="300px"
            overflowY="auto"
          >
            {collection.items.map((option) => (
              <Select.Item
                key={option.value}
                item={option}
                padding={3}
                color="neutral.80"
                textStyle="body3"
                _hover={{ backgroundColor: 'neutral.10', color: 'neutral.80' }}
                _selected={{ backgroundColor: 'brand.30', color: 'common.100' }}
                transition="all 0.2s"
              >
                {option.label}
                <Select.ItemIndicator />
              </Select.Item>
            ))}
          </Select.Content>
        </Select.Positioner>
      </Select.Root>
    </Flex>
  );
};

export default ProductFinderSelect;
